let accounting = require("accounting");

let accountingSettings = {
  currency: {
    symbol: "$" // default currency symbol is '$'
    , format: "%s%v" // controls output: %s = symbol, %v = value/number (can be object: see below)
    , decimal: "." // decimal point separator
    , thousand: "," // thousands separator
    , precision: 2 // decimal places
  }
  , number: {
    precision: 0 // default precision on numbers is 0
    , thousand: ","
    , decimal: "."
  }
};

export const getAccounting = function (settings) {
  accounting.settings = accountingSettings;
  if (settings) accounting.settings = settings;

  return accounting;
};

export const setSelectsInactiveData = function (val, completeList, filteredList) {
  if (val && filteredList.find((item) => item.code == (isNaN(val) ? val : Number(val))) == undefined) {
    const elem = completeList.find((item) => item.code == (isNaN(val) ? val : Number(val)));
    filteredList.push(elem);
  }
};

export const setSelectsInactiveDataField = function (obj, field, completeList, filteredList) {
  if (obj && filteredList.find((item) => item.code == (isNaN(obj[field]) ? obj[field] : Number(obj[field]))) == undefined) {
    const elem = completeList.find((item) => item.code == (isNaN(obj[field]) ? obj[field] : Number(obj[field])));
    filteredList.push(elem);
  }
};

export const setSelectsInactiveDataMultipleComma = function (val, completeList) {
  if (val && val != "") {
    const responseList = val.split(",");
    if (responseList && responseList.length > 0) {
      return completeList.filter((value) => {
        if (value.status) return value;
        const res = responseList.filter((value1) => value1 == value.code);
        return res.length > 0 ? res : null;
      });
    }
  }
  return completeList.filter((value) => value.status);
};

export const setSelectsInactiveDataMultipleJson = function (val, completeList) {
  if (val && val != "") {
    const responseList = JSON.parse(val);
    if (responseList && responseList.length > 0) {
      return completeList.filter((value) => {
        if (value.status) return value;
        const res = responseList.filter((value1) => value1.code == value.code);
        return res.length > 0 ? res : null;
      });
    }
  }
  return completeList.filter((value) => value.status);
};



// WEBPACK FOOTER //
// ./src/helpers/form-common.js